module.exports = __webpack_public_path__ + "img/gq.gqd338046.svg";